import { ck, interact } from "fire-wind-water";
import service from "../service/form";
import { settingMeetingData } from "../common/settingData";
import * as sbaseData from "../common/sbase";
import { $extras } from "../../stempcore/src/core/sextra";
import moment from "moment";
export default {
  data() {
    return {
      seminarInfo: {},
      posterInfo: {},
      posterUrl: "",
      isSetting: sbaseData.isSetting,
    };
  },
  methods: {
    /* 获取海报信息 */
    getPostInfo() {
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
        expandInfo: ["poster"],
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.posterInfo = data.content;

          this.posterUrl = `${window.location.protocol}${
            data.content.poster.wap ? data.content.poster.wap.formalUrl : ""
          }${data.content.weChatId || ""}&schemaId=${
            data.content.schemaId || 0
          }`;
          if (typeof this.getSignUpStatus === "function") {
            this.getSignUpStatus();
          }
        }
      });
    },

    /* 获取会议信息 */
    getEventInfo() {
      if (sbaseData.isSetting) {
        this.seminarInfo = settingMeetingData;
        document.body.style.setProperty(
          "--themeColor",
          "rgba(20, 104, 249, 1)"
        );
        document.body.style.setProperty(
          "--themeColorClear",
          "rgba(20, 104, 249, .2)"
        );
        return;
      }
      if (interact.isMobile) {
        this.getPostInfo();
      }
      this.getPostInfo();
      let param = {
        instanceId: sbaseData.instanceId,
        globalUserId: ck.cookie("globalUserId"),
      };
      service.getTopicTemplateSeminar(param).then((data) => {
        if (data.content) {
          this.seminarInfo = data.content;
          const param = {
            tenantId: this.tenantId,
            configId: data.content.topicConfigId,
          };

          service.getTemplateConfig(param).subscribe((res) => {
            if (res.result == 0) {
              const extras = $extras(res.content.info.html).extras;
              if (extras.themecolor && extras.themecolor.bgcolor) {
                let themeColorClear = "";
                const rgbaAttr = extras.themecolor.bgcolor.match(/[\d.]+/g);
                if (rgbaAttr.length >= 3) {
                  let r, g, b;
                  r = rgbaAttr[0];
                  g = rgbaAttr[1];
                  b = rgbaAttr[2];
                  themeColorClear =
                    "rgba(" + r + "," + g + "," + b + "," + 0.2 + ")";
                }

                document.body.style.setProperty(
                  "--themeColor",
                  extras.themecolor.bgcolor
                );
                document.body.style.setProperty(
                  "--themeColorClear",
                  themeColorClear
                );
              }
              console.log(11111);
              this.$store.commit("setExtras", extras);

              //this.extras.formfield.model = 'style1-wap'
            } else {
              window.$sk.tips.show(res.desc);
            }
          });
        }
      });
    },

    handleTimeStampToDateTime(timeStamp, format) {
      return moment(timeStamp).format(format);
    },
    handleTimeStamps(startTimeStamp, endTimeStamp) {
      let startTimeYear = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY"
      );
      let endTimeYear = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY"
      );
      let startDate = this.handleTimeStampToDateTime(
        startTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      let endDate = this.handleTimeStampToDateTime(
        endTimeStamp * 1000,
        "YYYY-MM-DD"
      );
      if (startDate == endDate) {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日 HH:mm"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "HH:mm")
        );
      } else if (startTimeYear == endTimeYear) {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "MM月DD日")
        );
      } else {
        return (
          this.handleTimeStampToDateTime(
            startTimeStamp * 1000,
            "YYYY年MM月DD日"
          ) +
          "~" +
          this.handleTimeStampToDateTime(endTimeStamp * 1000, "YYYY年MM月DD日")
        );
      }
    },
  },
};
